// import mpro from './mpro.init';

const pageShowEvent = function pageShowEvent(event) {
	// Page restored from BFCache
	if (event.persisted) {
		// console.log('This page was restored from the bfcache.');
		mpro.emit('page.restore', { type: 'page.restore' });
	}
	// Page loaded normally
	else {

		// Disable popstate auto-scrolling
		if (mpro.config.shop.scroll_restoration === 'manual') {
			window.history.scrollRestoration = 'manual';
		}

		// console.log('This page was loaded normally.');
		mpro.emit('page.show', { type: 'page.show' });
	}
};

const pageHideEvent = function pageHideEvent(event) {
	// Page might be sent to BFCache
	if (event.persisted === true) {
		// console.log('This page *might* be entering the bfcache.');
		mpro.emit('page.freeze', { type: 'page.freeze' });
	}
	// Page unloaded normally
	else {
		// console.log('This page will unload normally and be discarded.');
		mpro.emit('page.hide', { type: 'page.hide' });
	}
};

mpro.initPageEvents = () => {
	window.addEventListener('pageshow', pageShowEvent);
	window.addEventListener('pagehide', pageHideEvent);
};

mpro.removePageEvents = () => {
	window.removeEventListener('pageshow', pageShowEvent);
	window.removeEventListener('pagehide', pageHideEvent);
};

// Shortcut helpers
mpro.onPageFreeze = (handler) => {
	mpro.on('page.freeze', handler);
};
mpro.oncePageFreeze = (handler) => {
	mpro.once('page.freeze', handler);
};
mpro.onPageRestore = (handler) => {
	mpro.on('page.restore', handler);
};
mpro.oncePageRestore = (handler) => {
	mpro.once('page.restore', handler);
};

export default mpro;
